export type TrueLarkBusiness = {
  tlBusinessId: string;
  name: string;
  domain: TrueLarkDomains;
  businessType: string;
};

export type TrueLarkLocationResponse = {
  businesses: TrueLarkBusiness[];
};

export type TrueLarkPlansResponse = {
  plans: TrueLarkPlanResponse[];
};

export type SubscriptionStatus = 'SIGN_UP' | 'APPROVED' | 'LIVE' | 'SUSPENDED' | 'UNSUBSCRIBED' | 'DELETED';

export type TrueLarkDomains = 'FITNESS' | 'DENTAL' | 'SALON';

export type TrueLarkFeatureStatus = 'ENABLED' | 'DISABLED';

export type TrueLarkSubscriptionResponse = {
  subscriptionStatus: SubscriptionStatus;
};

export type TrueLarkPlanResponse = {
  id: string;
  name: string;
  status: string;
  domain: TrueLarkDomains;
  bookingSW: string;
  outreachSmsLimit: number;
  marketingStaffLimit: number;
  missedCallResponse: TrueLarkFeatureStatus;
  leadEngage: TrueLarkFeatureStatus;
  webChat: TrueLarkFeatureStatus;
  webToText: TrueLarkFeatureStatus;
  onlineBooking: TrueLarkFeatureStatus;
  multiLocationDashboard: TrueLarkFeatureStatus;
  businessMessenger: TrueLarkFeatureStatus;
  appointmentReminders: TrueLarkFeatureStatus;
  abandonedCalls: TrueLarkFeatureStatus;
  voiceReminders: TrueLarkFeatureStatus;
  incomingVoice: TrueLarkFeatureStatus;
};

export type TrueLarkBusinessDetails = {
  tlBusinessId: string;
  weaveLocationId: string;
  kind: string;
  businessName: string;
  assignedPhone?: {
    countryCode?: number | null;
    nationalNumber?: string | null;
    extension?: string | null;
    italianLeadingZero?: boolean | null;
    numberOfLeadingZeros?: number | null;
    rawInput?: string | null;
    countryCodeSource?: string | null;
    preferredDomesticCarrierCode?: string | null;
  };
  pmsNameAndId?: { id: string; name: string };
  associatedPms: string;
  lastSyncTime: string;
  email: string;
};

export type UpdateSubscriptionRequest = {
  tl_business_id: string;
  subscription_status: SubscriptionStatus;
  updated_by: string;
  update_reason?: string;
  send_email_notification: boolean;
};

export type BusinessPlanDetails = {
  plan: TrueLarkPlanResponse;
};

export type UpdateBusinessPlanRequest = {
  client_email: string;
  date: string;
  plan_id: string;
  updated_by: string;
};

export const SUBSCRIPTION_STATUSES = [
  { value: 'SIGN_UP', label: 'Sign Up' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'LIVE', label: 'Live' },
  { value: 'SUSPENDED', label: 'Suspended' },
  { value: 'UNSUBSCRIBED', label: 'Unsubscribed' },
  { value: 'DELETED', label: 'Deleted' },
];

export const subscriptionChipVariant = (
  status: SubscriptionStatus
): 'neutral' | 'active' | 'success' | 'warn' | 'critical' | 'disabled' => {
  switch (status) {
    case 'SIGN_UP':
      return 'neutral';
    case 'APPROVED':
      return 'active';
    case 'LIVE':
      return 'success';
    case 'SUSPENDED':
      return 'warn';
    case 'UNSUBSCRIBED':
      return 'critical';
    case 'DELETED':
      return 'disabled';
    default:
      return 'neutral';
  }
};
